/* eslint-disable import/prefer-default-export */
require('typeface-open-sans');

export const onClientEntry = async () => {
  if (typeof IntersectionObserver === 'undefined') {
    await import('intersection-observer');
  }
};
